export default __webpack_public_path__ + "static/media/Banner-promo-mktyventas-backg.c734e648.jpg";